<template>
  <div class="ba-page-report"
       :class="[{ bookmarked: pageData.bookmark }, domain.shared]"
       ref="pageReport">
    <div class="report-header">
      <div v-if="group !== false"
           class="group">
        <div v-if="pageData.tagInfo && pageData.tagInfo[group].tagId > -1">
          <span class="tag-bullet">
            <span :style="{ background: pageData.tagInfo[group].colorHex }"></span>
          </span><span class="tag-name">
            {{ pageData.tagInfo[group].tagName | onlySubdomain(journeyOptions.domain) }}
          </span>
        </div>
        <div v-else
             class="upcoming">
          <span class="tag-bullet">
            <i class="icon icon--upcoming-white"></i>
          </span><span class="tag-name">
            {{ $t('group.upcoming') }}
          </span>
        </div>
      </div>
      <template v-if="!isCustomNode">
        <div class="category-wrap" v-if="domain.matchType !== 'exact'">
          <div class="title">
            <i class="icon icon--ai-report-logo"></i>
            <span class="text">{{ $t('journey.nodeReport.AIPageType') }}</span>
          </div>
          <div class="category-detail" :class="[isCategoryNotEtc(pageData.AICategory1, 2) ? pageData.AICategory1 : 'etc']">
            <div class="secondary">
              <i class="icon" :class="[isCategoryNotEtc(pageData.AICategory1, 2) ? `icon-${pageData.AICategory1}` : 'icon-etc']"></i>
              <p class="secondary-title">{{ findCategoryName(pageData.AICategory1, 2) }}</p>
            </div>
            <div class="line"></div>
            <div class="detail-wrap">
              <template v-if="pageData.AICategory2.length !== 0">
                <div class="tertiary" v-for="(item, index) in pageData.AICategory2" :key="index">
                  <i class="icon" :class="[isCategoryNotEtc(item, 3) ? `icon-tertiary-${item}` : 'icon-etc']"></i>
                  <p class="tertiary-title">{{ findCategoryName(item, 3) }}</p>
                </div>
              </template>
              <template v-else>
                <div class="tertiary" >
                  <p class="tertiary-title">{{ $t(`common.category3.noData`) }}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="url">
          <a :href="pageData.url" target="_blank">
          <span class="title" :class="{noTitle: !pageData.title}">
            <i class="icon icon--ba-link gray"></i>
            {{ pageData.title ? pageData.title : 'No page title' }}
          </span>
          </a>
          <span class="link"
                :class="{ only: !pageData.title || !pageData.title.trim() }">
            {{ simpleUrl(pageData.url) }}
          </span>
          <template>
            <ui-bookmark-button :bookmarked="pageData.bookmark"
                                :disabled="isDemo"
                                @click="makeFavorite" />
          </template>

        </div>
      </template>
      <template v-else>
        <div class="group">
          <span class="tag-bullet">
              <span :style="{ background: pageData.customColor }"></span>
          </span>
          <span class="tag-name custom">
            {{ pageData.customId === 0 ? $t('customTag.untaggedLabel'): pageData.customValue}}
          </span>
        </div>
      </template>

      <div class="targeting-button-wrap">
        <node-report-targeting-button :visible="pageData.bookmark || (isCustomNode && pageData.customId !== 0)"
                                      :gUrlId="!isCustomNode ? (pageData.gUrlId || pageData.key) : pageData.customId"
                                      :isCustomNode="isCustomNode"
                                      :nodeData="pageData" />
      </div>

      <div class="thumbnail-carousel">
        <div class="thumbnail-container">
          <div class="thumbnail-wrap custom" v-if="isCustomNode">
            <div class="thumbnail desktop">
              <div class="image custom" :style="{'background-color': pageData.customColor}">
                <div class="value">
                  <span>{{ pageData.customId === 0 ? $t('customTag.untaggedLabel'): pageData.customValue }}</span>
                </div>
                <div class="meta">
                  <span>{{ $t('customTag.nodeReport.noScreen') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="thumbnail-wrap" v-else
               :style="{ 'margin-left': `-${100 * carouselPosition}%` }">
            <div v-for="device in ['desktop', 'tablet', 'phone']"
                 class="thumbnail"
                 :class="[ device, { 'no-thumbnail': !imagePath[device] }]"
                 :key="`thumb-${device}`">
              <p class="alert" v-if="!imagePath[device]">
                <i class="icon icon--ring"></i>
                <span v-html="$t('journey.noScreenshot')"></span>
              </p>
              <div class="image">
                <transition name="fade">
                  <div class="loading" v-show="capturing(device)">
                    <span class="loading-circle">
                      <svg x="0px" y="0px" viewBox="0 0 150 150">
                        <circle class="loading-inner" cx="75" cy="75" r="60"/>
                      </svg>
                    </span>
                  </div>
                </transition>
                <div class="capture"
                     :style="{ 'background-image': `url('${getS3Url(imagePath[device] || defaultThumbnail)}')` }"></div>
                <div class="meta"
                     v-if="imagePath[device]">
                  <template v-if="captureType(imagePath[device]) === 'upload'">
                    {{ $t('journey.uploadDate') }}:
                  </template>
                  <template v-else>
                    {{ $t('journey.captureDate') }}:
                  </template>
                  {{ captureDate(detailData.realCaptureDate[device]) }}
                  <button v-if="!capturing(device)"
                          @click="onCapture(device)" :class="{disabled: isDemo}">
                    <i class="icon icon--retake-white"></i>
                    {{ $t('common.retake') }}
                  </button>
                </div>
                <div class="buttons" v-else>
                  <button v-if="!capturing(device)"
                          @click="onCapture(device)" :class="{disabled: isDemo}">
                    <i class="icon icon--retake-white"></i>
                    {{ $t('journey.screenshot') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <template v-if="!isCustomNode">
          <button class="move left"
                  :disabled="carouselPosition < 1"
                  @click="moveCarouselLeft">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
              <path fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.073 2.5L5 8 10.073 13.527" />
            </svg>
          </button>
          <button class="move right"
                  :disabled="carouselPosition > 1"
                  @click="moveCarouselRight">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
              <path fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.073 2.5L6 8 11.073 13.527" transform="matrix(-1 0 0 1 17.073 0)"/>
            </svg>
          </button>

          <div class="bullets">
            <span v-for="idx in [0, 1, 2]"
                  class="bullet"
                  :class="{ active: carouselPosition === idx }"
                  :key="`bullet${idx}`"
                  @click="moveCarousel(idx)"></span>
          </div>
        </template>
      </div>
    </div>
    <div class="report-body">
      <div class="ranking">
        <p class="notice">
          <i class="icon icon--ring-purple"></i>
          {{ $t('ranking.top100Url') }}
        </p>
        <table>
          <thead>
          <tr>
            <th class="item--rank">{{ $t('common.rank') }}</th>
            <th class="item--url">
              {{ $t('ranking.includedUrl.title') }}
              <ui-icon-tooltip :iconSize="'outline-white'"
                               arrowBottom
                               arrowCenter>
                <span v-html="includedUrlTooltip"></span>
              </ui-icon-tooltip>
            </th>
            <th class="item--session">{{ $t('common.pv') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="([url, pv], idx) in urlList"
              :key="`ranking${url}`">
            <td v-if="idx < 1 || urlList[idx][1] !== urlList[idx - 1][1]"
                class="item--rank">
              {{ idx + 1 }}
            </td>
            <td v-else
                class="item--rank blank">
            </td>
            <td class="item--url">
              <a :href="`${url}`"
                 target="_blank">
                <span class="url">{{ url }}</span>
              </a>
            </td>
            <td class="item--session" :class="{ big: url.session > 999999 }">
              {{ calculatedPV(pv) | thousand }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <back-to-top :refName="'pageReport'" />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {
  simpleUrl,
  getS3CaptureType,
  getS3Url,
  dateFormatTimezone,
  getPercentage,
  getDomainForView
} from '@/libs/utils'

import UiIconTooltip from '@/components/ui/UiIconTooltip'
import UiBookmarkButton from '@/components/ui/UiBookmarkButton'
import BackToTop from '@/components/ui/ba/BackToTop'
import NodeReportTargetingButton from '@/components/targeting/NodeReportTargetingButton'
import { AI_CATEGORY_SECONDARY, AI_CATEGORY_TERTIARY } from '@/libs/constants'

export default {
  name: 'PageReport',
  components: {
    UiIconTooltip,
    UiBookmarkButton,
    BackToTop,
    NodeReportTargetingButton
  },
  computed: {
    ...mapState([
      'journeyOptions',
      'numBookmarks',
      'domain',
      'originRankingData',
      'isSampling',
      'isDemo'
    ]),
    urlList () {
      if (this.detailData.list) {
        const domain = this.domain.domain
        const domainForView = getDomainForView(domain)
        const list = Object.entries(this.detailData.list)

        if (domain.startsWith('xn--') > -1) {
          const listForView = []
          for (let i = 0; i < list.length; i++) {
            const item = list[i]
            let url = item[0]
            const count = item[1]
            if (url.indexOf(domain) > -1) {
              url = url.replace(domain, domainForView)
            }

            listForView.push([url, count])
          }
          return listForView
        } else {
          return list
        }
      }
      return []
    },
    imagePath () {
      return this.detailData.imagePath || {}
    },
    includedUrlTooltip () {
      if (this.isCustomNode) {
        return this.$t('customTag.nodeReport.urlTooltip')
      }

      if (this.domain.matchType === 'exact') {
        return this.$t('registration.detailTarget.ad.tooltip')
      }

      return this.$t('ranking.includedUrl.description')
    }
  },
  methods: {
    ...mapMutations([
      'setBookmarkListLayerOptions'
    ]),
    calculatedPV (pv) {
      return getPercentage(pv, this.pageData.count).toFixed(1) + '%'
    },
    capturing (device) {
      return this.captureProcessing && this.captureProcessing.urlId === this.pageData.gUrlId
    },
    onCapture (device) {
      if (this.isDemo) {
        return false
      }
      this.$emit('onCapture', { ...this.pageData, ...this.detailData }, device)
    },
    makeFavorite () {
      this.$emit('makeFavorite', this.pageData)
    },
    simpleUrl (url) {
      return simpleUrl(url, this.journeyOptions.matchType)
    },
    getS3Url (value) {
      return getS3Url(value)
    },
    captureDate (value) {
      return dateFormatTimezone(value, this.timezoneName, 'YYYY.M.D')
    },
    captureType (imagePath) {
      return getS3CaptureType(imagePath)
    },
    moveCarouselLeft () {
      this.carouselPosition = Math.max(this.carouselPosition - 1, 0)
    },
    moveCarouselRight () {
      this.carouselPosition = Math.min(this.carouselPosition + 1, 2)
    },
    moveCarousel (idx) {
      this.carouselPosition = idx
    },
    findCategoryName (name, type) {
      switch (type) {
        case 2:
          if (AI_CATEGORY_SECONDARY.find((item) => item === name)) {
            return this.$t(`common.category2.${name}`)
          } else {
            return this.$t(`common.category2.etc`)
          }
        case 3:
          if (AI_CATEGORY_TERTIARY.find((item) => item === name)) {
            return this.$t(`common.category3.${name}`)
          } else {
            return this.$t(`common.category3.etc`)
          }
        default:
          return this.$t(`common.category2.etc`)
      }
    },
    isCategoryNotEtc (name, type) {
      return this.findCategoryName(name, type) !== this.$t(`common.category2.etc`)
    }
  },
  props: [
    'pageData',
    'detailData',
    'defaultThumbnail',
    'captureProcessing',
    'group',
    'timezoneName',
    'isCustomNode'
  ],
  data () {
    return {
      carouselPosition: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.ba-page-report {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  a {
    color: inherit;
  }

  i.icon {
    vertical-align: middle;
    color: #222;
  }

  .report-header {
    position: relative;
    box-sizing: border-box;
    padding-top: 40px;
    background-color: #4b5263;

    .group {
      padding: 1px 20px 0 22px;

      .tag-bullet {
        display: inline-block;
        vertical-align: top;
        width: 12px;
        height: 12px;
        margin-top: 1px;

        span {
          display: block;
          width: 12px;
          height: 12px;
          border-radius: 12px;
          border: 1px solid #ffffff;
        }

        .icon {
          vertical-align: middle;
        }
      }

      .tag-name {
        width: calc(100% - 76px);
        display: inline-block;
        vertical-align: top;
        line-height: 1.38;
        font-size: 13px;
        color: #c1c1c1;
        word-break: break-all;
        margin: 0 0 12px 12px;
        padding: 0 50px 12px 0;
        border-bottom: 1px dashed #888888;

        &.custom {
          border-bottom: initial;
          margin-bottom: 0;
          padding-bottom: 0;
        }
      }
    }

    .category-wrap {
      margin-bottom: 22px;
      padding: 0 20px;
      .title {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-bottom: 13px;
        > .icon.icon--ai-report-logo {
          width: 20px;
          height: 20px;
        }
        > .text {
          color: white;
          font-size: 14px;
          font-weight: 500;
          line-height: 120%; /* 16.8px */
        }
      }
      .category-detail {
        border-radius: 6px;
        padding: 15px;
        box-sizing: border-box;

        .secondary {
          display: flex;
          align-items: center;
          gap: 10px;
          > .icon {
            font-size: 26px;
            &:before {
              background: transparent;
            }
          }

          > .secondary-title {
            color: #222;
            font-size: 18px;
            font-weight: 600;
            line-height: 120%; /* 21.6px */
          }
        }

        .line {
          height: 1px;
          width: 100%;
          background: rgba(34, 34, 34, 0.30);
          margin: 13px 0;
        }

        .detail-wrap {
          padding-left: 5px;
          .tertiary {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 11px;
            margin-bottom: 6px;

            .icon {
              font-size: 16px;
            }

            .tertiary-title {
              color: #222;
              font-size: 15px;
              font-weight: 500;
              line-height: 120%; /* 18px */
            }
          }
        }
      }
    }

    .url {
      position: relative;
      padding: 0 20px;

      .title {
        position: relative;
        display: block;
        font-size: 18px;
        line-height: 23px;
        font-weight: 500;
        color: #ffffff;
        margin-top: 2px;
        padding: 0 45px 0 24px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.19);
        transition: padding-right 0.3s $ease-out-quart;

        i {
          position: absolute;
          top: 4px;
          left: 0;
          margin-right: 5px;
          transform: translateY(-1px);
        }

        &.noTitle {
          font-style: italic;
          color: #d7d7d7;
        }
      }

      .link {
        margin-top: 10px;
        padding-left: 24px;
        line-height: 1.38;
        display: block;
        font-size: 13px;
        color: #c1c1c1;
        word-break: break-all;

        &.only {
          margin-top: 2px;
          padding-right: 80px;
        }
      }

      .bookmark-button {
        position: absolute;
        top: -4px;
        right: 20px;
      }
    }

    .targeting-button-wrap {
      margin: 0 20px;
    }

    .thumbnail-carousel {
      position: relative;
      white-space: nowrap;

      .thumbnail-container {
        overflow: hidden;

        .thumbnail-wrap {
          width: 300%;
          transition: margin-left 0.3s cubic-bezier(.28, .12, .42, .94);

          &.custom {
            padding-bottom: 17px;
          }
        }
      }

      .move {
        position: absolute;
        top: calc(50% - 26px);
        width: 28px;
        height: 28px;
        padding-top: 3px;
        border-radius: 5px;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
        background-color: #fff;
        transition: opacity 0.3s ease;

        svg {
          path {
            stroke: #444444;
            transition: stroke 0.2s ease;
          }
        }

        &:disabled {
          opacity: 0;
          cursor: default;
        }

        &:not(:disabled):hover {
          background-color: #efefef;
        }

        &:not(:disabled):active {
          background-image: linear-gradient(to top, #888888 0%, #666666 100%);
          box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(0, 0, 0, 0.06);
          color: #ffffff;

          svg {
            path {
              stroke: #ffffff;
            }
          }
        }

        &.left {
          left: 8px;
          padding-right: 2px;
        }

        &.right {
          right: 8px;
          padding-left: 2px;
        }
      }

      .bullets {
        text-align: center;
        padding: 15px 0 12px;

        .bullet {
          display: inline-block;
          width: 8px;
          height: 8px;
          margin: 0 5px;
          background-color: #fff;
          opacity: 0.2;
          transition: opacity 0.2s ease;
          border-radius: 5px;
          cursor: pointer;

          &.active {
            opacity: 1;
          }
        }
      }
    }

    .thumbnail {
      position: relative;
      width: 390px;
      max-width: calc(33.333333% - 40px);
      display: inline-block;
      margin: 15px 20px 0;

      .alert {
        position: absolute;
        width: calc(100% - 50px);
        padding: 8px 0 8px 30px;
        top: 10px;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 2px;
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08), 0 2px 3px 0 rgba(0, 0, 0, 0.12);
        background-color: #f4e439;
        color: #555555;
        font-size: 12px;
        z-index: 3;
        text-align: center;

        .icon {
          position: absolute;
          top: 50%;
          left: 4px;
          transform: translateY(-50%);
        }
      }

      .image {
        box-shadow: 0 12px 13px -7px rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.15);
        border: solid 2px #ffffff;
        background-color: #ffffff;
        max-width: 100%;
        border-radius: 10px;
        box-sizing: border-box;
        margin: 0 auto;
        overflow: hidden;
        position: relative;

        .loading {
          position: absolute;
          top: calc(50% - 27px);
          left: calc(50% - 19px);
          padding: 7px;
          border-radius: 8px;
          background-color: #ffffff;
          width: 24px;
          height: 24px;
          z-index: 10;

          .loading-circle {
            position: absolute;
            width: 24px;
            height: 24px;
            transform: translate(-50%, -50%);
            animation: loading 3s linear infinite;
            transition: opacity 0.3s ease;

            svg {
              height: 100%;
            }

            .loading-inner {
              stroke: {
                dashoffset: 0;
                dasharray: 300;
                width: 20;
                miterlimit: 10;
                linecap: round;
              }

              animation: loading-circle 2s linear infinite;
              stroke: $brandColor;
              fill: transparent;
            }
          }
        }

        @keyframes loading {
          0% {
            transform: rotate(0);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes loading-circle {
          0% {
            stroke-dashoffset: 0
          }
          100% {
            stroke-dashoffset: -600;
          }
        }

        .capture {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background-size: cover;
          border-radius: 8px;
        }

        button {
          border-radius: 4px;
          box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.4);
          background-color: #272727;
          color: #ffffff;
          padding: 5px 7px 4px 7px;
          transition: background-color 0.2s ease;
          white-space: nowrap;

          .icon {
            position: relative;
            top: -1px;
            vertical-align: middle;
          }

          &:hover {
            background-color: #4a4a4a;
          }
        }

        .meta {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          box-sizing: border-box;
          background-color: rgba(0, 0, 0, 0.85);
          padding: 19px 15px;
          font-size: 12px;
          color: #ffd418;
          transform: translateY(100%);
          transition: transform 0.3s ease;

          button {
            position: absolute;
            bottom: 9px;
            right: 8px;

            &.disabled {
              opacity: 0.5;
            }
          }
        }

        .buttons {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          &.disabled {
            opacity: 0.5;
          }
        }

        &:hover {
          .meta {
            transform: translateY(0);
          }
        }

        &.custom {
          .meta {
            text-align: center;

            & span {
              display: inline-block;
            }
          }

          .value {
            padding: 15px;
            & span {
              color: #FFF;
              font-size: 20px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
            }
          }
        }
      }

      &.desktop {
        &:after {
          width: 390px;
        }
        .image {
          width: 390px;
          height: 252px;
        }
      }

      &.tablet {
        &:after {
          width: 192px;
        }
        .image {
          width: 192px;
          height: 252px;

          .meta {
            text-align: center;
            padding-top: 10px;
            padding-bottom: 50px;

            button {
              left: 50%;
              bottom: 9px;
              transform: translateX(-50%);
            }
          }
        }
      }

      &.phone {
        &:after {
          width: 162px;
        }
        .image {
          width: 162px;
          height: 252px;

          .meta {
            text-align: center;
            padding-top: 10px;
            padding-bottom: 50px;

            button {
              left: 50%;
              bottom: 9px;
              transform: translateX(-50%);
            }
          }
        }
      }

      &.no-thumbnail {
        .image {
          .capture {
            transform: scale(1.175);
            filter: blur(15px);
          }
        }

        &.tablet,
        &.phone {
          .alert {
            top: 22px;
            width: 257px;
          }
        }
      }
    }
  }

  .report-body {
    padding: 0 20px 35px 20px;
    .pv {
      display: flex;
      flex-direction: column;
      padding: 20px;
      margin-top: 20px;
      border-radius: 14px;
      box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.15), 0px 12px 13px -7px rgba(0, 0, 0, 0.16);
      &-header {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 29px;
        color: #555;
        font-size: 15px;
        font-weight: 700;
      }
      &-total {
        margin-bottom: 23px;
        color: #555;
        font-size: 42px;
        font-weight: 700;
      }
      &-list {
        &-item {
          display: flex;
          align-items: center;
          padding: 10px 0;
          .label {
            width: 110px;
            font-size: 14px;
            font-weight: 500;
          }
          .value {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &-text {
              display: flex;
              align-items: center;
              gap: 2px;
              font-size: 16px;
              font-weight: 600;
              line-height: 1.12;
              .percent {
                font-size: 14px;
                font-weight: 400;
              }
            }
            .icon {
              width: 24px;
              height: 24px;
            }
          }
          &:not(:last-child) {
            border-bottom: 1px solid #D8D8D8;
          }
          &.duration {
            color: #4B8F0D;
          }
          &.dropOffPv {
            color: #FF4A00;
          }
          &.refresh {
            color: #0074FF;
          }
          &.rollback {
            color: #9665E3;
          }
        }
      }
    }

    .ranking {
      position: relative;
      margin-top: 20px;
      padding: 1px 20px 20px;
      border-radius: 14px;
      box-shadow: 0 12px 13px -7px rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.15);
      background-color: #fff;

      .notice {
        font-size: 12px;
        line-height: 1.5;
        color: #9665e3;
        margin: 20px -20px;
        text-align: center;
      }

      table {
        font-size: 13px;
        width: 100%;

        th {
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 1;
          letter-spacing: normal;
          color: #767676;
          padding: 13px 10px 7px 10px;
          border-bottom: 1px solid #bbbbbb;
          font-size: 13px;

          &.item--rank {
            text-align: center;
            padding-right: 0;
            padding-left: 0;
          }

          &.item--url {
            text-align: center;
          }

          &.item--session {
            text-align: right;
            padding-right: 0;
            padding-left: 0;
          }

          .tooltip {
            vertical-align: middle;
            margin-left: 2px;
            font-weight: normal;

            & /deep/ .bubble {
              transform: translate(calc(-50% - 2px), -2px) !important;
            }
          }
        }

        td {
          border-top: 1px solid #ebebeb;
          vertical-align: middle;
          line-height: 1.23;
          font-size: 13px;
          font-weight: normal;
          color: #777777;

          &.item--rank {
            padding: 16px 0;
            width: 40px;
            line-height: 18px;
            font-size: 14px;
            text-align: center;

            &.blank {
              border-top: none;
            }

            &.big {
              font-size: 12px;
            }
          }

          &.item--url {
            line-height: 14px;
            padding: 10px;

            .url {
              word-break: break-all;
            }
          }

          &.item--session {
            text-align: right;
            width: 55px;
            white-space: nowrap;
            padding: 10px 0;

            &.big {
              font-size: 12px;
            }
          }
        }

        tr {
          &:last-child {
            td {
              border-bottom: 1px solid #ebebeb;
            }
          }
        }
      }
    }
  }
  &.shared {
    .bookmark-button  /deep/ {
      pointer-events: none;
      .button {
        background-color: transparent;
        box-shadow: none;
        opacity: .3;
      }
    }
  }

  .fade-enter-active {
    transition: opacity 0.5s ease;
    z-index: 1;
  }
  .fade-leave-active {
    transition: opacity 0.3s ease;
    z-index: 1;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .back-to-top {
    padding-bottom: 30px;
  }
}
</style>
